var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Rx';
import { CommonService, SFUN } from '../../services/common.service';
import { AppComponent } from '../../app.component';
var SearchComponent = SearchComponent_1 = (function () {
    function SearchComponent(router, _comService) {
        this.router = router;
        this._comService = _comService;
        this.action = new EventEmitter(true);
        this._busAvanzada = false;
        this.searchTypes = SEARCH_TYPES.list();
        this.visibleCed = true;
        SearchComponent_1._observable = new Observable(function (observer) {
            return SearchComponent_1._observer = observer;
        }).share();
        this.filter = SEARCH_TYPES.forIndex(0);
    }
    SearchComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._subscription = AppComponent.observable().subscribe(function (item) { return _this.cargarMenuBusqueda(item); });
    };
    SearchComponent.prototype.cargarMenuBusqueda = function (val) {
        //console.log("LOCAL DATA " + val);
        //console.log("PERMISOS " + JSON.stringify(KeycloakService.usr.permisos));
        if (!val) {
            var index;
            if (!this._comService.tienePermiso(SFUN.Expedientes)) {
                index = this.searchTypes.indexOf(SEARCH_EXPEDIENTE);
                this.searchTypes.splice(index, 1);
            }
            if (!this._comService.tienePermiso(SFUN.Despacho)) {
                index = this.searchTypes.indexOf(SEARCH_DESPACHO);
                this.searchTypes.splice(index, 1);
            }
            if (!this._comService.tienePermiso(SFUN.Agenda)) {
                index = this.searchTypes.indexOf(SEARCH_AGENDA);
                this.searchTypes.splice(index, 1);
            }
            if (!this._comService.tienePermiso(SFUN.Cedulas)) {
                index = this.searchTypes.indexOf(SEARCH_CEDULA);
                this.searchTypes.splice(index, 1);
            }
            if (!this._comService.tienePermiso(SFUN.Usuarios)) {
                index = this.searchTypes.indexOf(SEARCH_USUARIO);
                this.searchTypes.splice(index, 1);
            }
            //console.log("search type " + this.searchTypes.length);
            //console.log("filter " + JSON.stringify(this.filter));
            if (this.searchTypes.length > 0) {
                this.filter = this.searchTypes[0].clone();
            }
        }
    };
    SearchComponent.prototype.handleKeypress = function (key) {
        var q = this.filter.query;
        if (key.code == "Delete" || key.code == "Backspace" || key.code.startsWith("Arrow")) {
            return true;
        }
        var code = key.key;
        if ((key.code == "NumpadDivide") || (key.code == "Digit7" && key.shiftKey)) {
            code = "/";
        }
        else if ((key.code.startsWith("Digit")
            || (key.code.startsWith("Numpad") && Number.isInteger(Number.parseInt(key.code.substring(key.code.length - 1)))))
            && key.key != "Enter") {
            code = key.code.substring(key.code.length - 1);
        }
        if (code == "Enter") {
            if (this.filter.id == SEARCH_DESPACHO.id || this.filter.id == SEARCH_AGENDA.id || this.filter.id == SEARCH_CEDULA.id) {
                if (q.length > 5 && q.length < 10) {
                    var fields = this.filter.query.split("/");
                    this.filter.query = fields[0] + "/" + fields[1] + "/2" + (new Array(3 - fields[2].length + 1).join("0") + fields[2]);
                }
                else if (q.length != 10) {
                    return false;
                }
            }
            this.search();
        }
        else {
            if (this.filter.id == SEARCH_DESPACHO.id || this.filter.id == SEARCH_AGENDA.id || this.filter.id == SEARCH_CEDULA.id) {
                if (code != "/" && !Number.isInteger(Number.parseInt(code))) {
                    return false; // solo sirve para la fecha [0-9/]
                }
                else {
                    if ((code == "/") && (q.length == 2 || q.length == 5)) {
                        return true; //[0-9][0-9] + / OR //[0-9][0-9]/[0-9][0-9] + /
                    }
                    else if ((code == "/") && (q.length == 1 || q.length == 4)) {
                        if (q.length == 1) {
                            this.filter.query = '0' + this.filter.query;
                        }
                        else if (q.length == 4) {
                            this.filter.query = this.filter.query.substr(0, 3) + "0" + this.filter.query.substr(3, 1);
                        }
                        return true;
                    }
                    else if (code != "/" && (q.length >= 0 && q.length != 2 && q.length != 5 && q.length < 10)) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            }
        }
    };
    SearchComponent.prototype.search = function () {
        //console.log("search.component metodo SEARCH");
        //console.log(this.filter);
        if (this.filter.id == SEARCH_CEDULA.id) {
            this.router.navigate(['/cedula'], { queryParams: { q: btoa(JSON.stringify(this.filter)) } });
        }
        else if (this.filter.id == SEARCH_USUARIO.id) {
            this.router.navigate(['/usuario'], { queryParams: { q: btoa(JSON.stringify(this.filter)) } });
        }
        else if (this.filter.id == SEARCH_DESPACHO.id) {
            this.router.navigate(['/despacho'], { queryParams: { q: btoa(JSON.stringify(this.filter)) } });
        }
        else if (this.filter.id == SEARCH_AGENDA.id) {
            this.router.navigate(['/agenda'], { queryParams: { q: btoa(JSON.stringify(this.filter)) } });
        }
        else {
            this.router.navigate(['/search'], { queryParams: { q: btoa(JSON.stringify(this.filter)) } });
        }
        //this.action.emit(this.filter);
        if (SearchComponent_1._observer) {
            SearchComponent_1._observer.next(this.filter);
        }
    };
    SearchComponent.observable = function () {
        return SearchComponent_1._observable;
    };
    SearchComponent.prototype.onFilterChange = function (value) {
        this.filter = SEARCH_TYPES.forIndex(value);
    };
    SearchComponent.prototype.onFilterChangeId = function (value) {
        //console.log("menu change " + value);
        this.filter = SEARCH_TYPES.forId(value);
    };
    Object.defineProperty(SearchComponent.prototype, "menuChange", {
        set: function (value) {
            if (typeof (value) != "undefined") {
                this.onFilterChange(value);
            }
        },
        enumerable: true,
        configurable: true
    });
    SearchComponent.prototype.stopClose = function (event) {
        // if (event.target.id !== 2 || event.target.id != 2 || event.target.id !== "2"){
        //   console.log("STOPPROPAGATION");
        //   event.stopPropagation();
        // }
        if (event.target.id == 2) {
            //console.log(" ");
        }
        else {
            //console.log("STOPPROPAGATION");
            event.stopPropagation();
        }
        if (event.target.id == 1) {
            this.filter.query = "";
        }
    };
    return SearchComponent;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], SearchComponent.prototype, "action", void 0);
__decorate([
    Input(),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [Number])
], SearchComponent.prototype, "menuChange", null);
SearchComponent = SearchComponent_1 = __decorate([
    Component({
        moduleId: module.id,
        selector: 'search-component',
        templateUrl: 'search.component.html'
    }),
    __metadata("design:paramtypes", [Router, CommonService])
], SearchComponent);
export { SearchComponent };
var SearchType = (function () {
    function SearchType(id, name, placeholder, query) {
        if (placeholder === void 0) { placeholder = ""; }
        if (query === void 0) { query = ""; }
        this.id = id;
        this.name = name;
        this.placeholder = placeholder;
        this.query = query;
    }
    SearchType.prototype.clone = function () {
        return new SearchType(this.id, this.name, this.placeholder, this.query);
    };
    return SearchType;
}());
export { SearchType };
var SEARCH_EXPEDIENTE = new SearchType(0, "Expedientes", "Ingrese Número/Año y/o fragmento de Carátula");
var SEARCH_DESPACHO = new SearchType(1, "Despacho Diario", "Fecha ../../..");
var SEARCH_CEDULA = new SearchType(2, "Cédulas", "Fecha ../../..");
var SEARCH_USUARIO = new SearchType(3, "Usuarios", "Ingrese Nombre, Apellido o Código de Usuario");
var SEARCH_AGENDA = new SearchType(4, "Agenda", "Fecha Audiencia ../../..");
export var SEARCH_TYPES = {
    "EXPEDIENTE": SEARCH_EXPEDIENTE,
    "DESPACHO": SEARCH_DESPACHO,
    "CEDULA": SEARCH_CEDULA,
    "USUARIO": SEARCH_USUARIO,
    "AGENDA": SEARCH_AGENDA,
    forIndex: function (i) {
        switch (i) {
            case 0: return SEARCH_EXPEDIENTE.clone();
            case 1: return SEARCH_DESPACHO.clone();
            case 2: return SEARCH_CEDULA.clone();
            case 3: return SEARCH_USUARIO.clone();
            case 4: return SEARCH_AGENDA.clone();
        }
    },
    forId: function (i) {
        switch (i) {
            case 0: return SEARCH_EXPEDIENTE.clone();
            case 1: return SEARCH_DESPACHO.clone();
            case 2: return SEARCH_CEDULA.clone();
            case 3: return SEARCH_USUARIO.clone();
            case 4: return SEARCH_AGENDA.clone();
        }
    },
    list: function () {
        return [SEARCH_EXPEDIENTE, SEARCH_DESPACHO, SEARCH_CEDULA, SEARCH_USUARIO, SEARCH_AGENDA];
    }
};
var SearchComponent_1;
//# sourceMappingURL=search.component.js.map